import * as i0 from '@angular/core';
import { Injectable, Inject, Component, ViewChild, Input, NgModule } from '@angular/core';
import { WINDOW, WindowModule } from '@upr-web-primer/window';
import { isEmpty, get } from 'lodash-es';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i1 from '@upr-web-primer/locale';

const facebookLocales = {
    en: 'en_US',
    es: 'es_LA',
    ja: 'ja_JP'
};
class FacebookLikeService {
    constructor(document, window, locale) {
        this.document = document;
        this.window = window;
        this.locale = locale;
    }
    init() {
        this.language = this.locale.getFromStorage().language;
        if (!this.document.getElementById(`facebook-jssdk-${this.language}`)) {
            const scriptUrl = `https://connect.facebook.net/${facebookLocales[this.language]}/sdk.js#xfbml=1&version=v3.0`;
            const script = this.document.createElement('script');
            script.async = true;
            script.defer = true;
            script.crossorigin = 'anonymous';
            script.src = scriptUrl;
            script.id = `facebook-jssdk-${this.language}`;
            this.document.body.appendChild(script);
        }
    }
    render() {
        if (this.window.FB) {
            this.window.FB.XFBML.parse();
        }
    }
}
FacebookLikeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FacebookLikeService, deps: [{ token: DOCUMENT }, { token: WINDOW }, { token: i1.LocaleService }], target: i0.ɵɵFactoryTarget.Injectable });
FacebookLikeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FacebookLikeService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FacebookLikeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i1.LocaleService }]; } });

class FacebookLikeComponent {
    constructor(window, facebookLike, renderer, zone) {
        this.window = window;
        this.facebookLike = facebookLike;
        this.renderer = renderer;
        this.zone = zone;
        this.action = 'like';
        this.layout = 'button_count';
        this.facebookLike.init();
    }
    ngAfterViewInit() {
        this.facebookLike.render();
        if (`${this.window.location.href}`.includes('ja/jp')) {
            this.observer = new MutationObserver(mutations => {
                if (!isEmpty(mutations)) {
                    const childNodes = get(this.facebookLikeRef, 'nativeElement.childNodes');
                    this.zone.runOutsideAngular(() => {
                        setTimeout(() => {
                            this.setFBLikeWidth(childNodes);
                        }, 500);
                    });
                }
            });
            const config = {
                childList: true
            };
            this.observer.observe(this.facebookLikeRef.nativeElement, config);
        }
    }
    setFBLikeWidth(nodeList) {
        if (!nodeList) {
            this.observer.disconnect();
            return;
        }
        nodeList.forEach((node) => {
            if (get(node, 'nodeType', 0) === Node.ELEMENT_NODE) {
                if (get(node, 'nodeName', '') === 'SPAN') {
                    this.renderer.setStyle(node, 'width', '130px');
                }
                if (get(node, 'nodeName', '') === 'IFRAME') {
                    this.renderer.setStyle(node, 'width', 'auto');
                    this.observer.disconnect();
                    return;
                }
                else {
                    this.setFBLikeWidth(node.childNodes);
                }
            }
        });
    }
    ngOnDestroy() {
        if (this.observer && this.observer.disconnect) {
            this.observer.disconnect();
        }
    }
}
FacebookLikeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FacebookLikeComponent, deps: [{ token: WINDOW }, { token: FacebookLikeService }, { token: i0.Renderer2 }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
FacebookLikeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: FacebookLikeComponent, selector: "upr-facebook-like", inputs: { action: "action", layout: "layout", share: "share", url: "url" }, viewQueries: [{ propertyName: "facebookLikeRef", first: true, predicate: ["facebookLikeRef"], descendants: true, static: true }], ngImport: i0, template: "<div\r\n\tclass=\"fb-like\"\r\n\t#facebookLikeRef\r\n\t[attr.data-layout]=\"layout\"\r\n\t[attr.data-action]=\"action\"\r\n\t[attr.data-share]=\"share\"\r\n\t[attr.data-href]=\"url\"\r\n></div>\r\n", styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fb-like{padding:8px 8px 0 0}.fb-like+p{display:inline-flex;margin:0;font-size:18px;font-weight:700}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FacebookLikeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'upr-facebook-like', template: "<div\r\n\tclass=\"fb-like\"\r\n\t#facebookLikeRef\r\n\t[attr.data-layout]=\"layout\"\r\n\t[attr.data-action]=\"action\"\r\n\t[attr.data-share]=\"share\"\r\n\t[attr.data-href]=\"url\"\r\n></div>\r\n", styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fb-like{padding:8px 8px 0 0}.fb-like+p{display:inline-flex;margin:0;font-size:18px;font-weight:700}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: FacebookLikeService }, { type: i0.Renderer2 }, { type: i0.NgZone }]; }, propDecorators: { facebookLikeRef: [{
                type: ViewChild,
                args: ['facebookLikeRef', { static: true }]
            }], action: [{
                type: Input
            }], layout: [{
                type: Input
            }], share: [{
                type: Input
            }], url: [{
                type: Input
            }] } });

class FacebookLikeModule {
}
FacebookLikeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FacebookLikeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FacebookLikeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FacebookLikeModule, declarations: [FacebookLikeComponent], imports: [CommonModule, WindowModule], exports: [FacebookLikeComponent] });
FacebookLikeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FacebookLikeModule, imports: [[CommonModule, WindowModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: FacebookLikeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, WindowModule],
                    declarations: [FacebookLikeComponent],
                    exports: [FacebookLikeComponent]
                }]
        }] });

export { FacebookLikeComponent, FacebookLikeModule, FacebookLikeService };
